import { render, staticRenderFns } from "./newOaWorkflowDetailList.vue?vue&type=template&id=10ec744c&scoped=true"
import script from "./newOaWorkflowDetailList.vue?vue&type=script&lang=js"
export * from "./newOaWorkflowDetailList.vue?vue&type=script&lang=js"
import style0 from "./newOaWorkflowDetailList.vue?vue&type=style&index=0&id=10ec744c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10ec744c",
  null
  
)

export default component.exports